"use client";
import { notFound } from "next/navigation";
import { ServicesContent } from "../data/prestations";
import { Banner } from "@/components/sections/Banner";
import { DescriptionFirst } from "../sections/DescriptionFirst";
import { DescriptionSecond } from "../sections/DescriptionSecond";
import { DescriptionThird } from "../sections/DescriptionThird";
import { PastWorks } from "../sections/Pastworks";
import { HeadSpaSoinsSection } from "../sections/HeadSpaSoinsSection";
import { HeadSpaDiagnosticSection } from "../sections/HeadSpaDiagnosticSection";
import { HeadSpaIntroSection } from "../sections/HeadSpaIntroSection";
import { HeadSpaVideoBanner } from "../components/HeadSpaVideoBanner";
import { HeadSpaReviewsWidget } from "../components/HeadSpaReviewsWidget";
import { ReviewsSection } from "@/components/sections/reviews/ReviewsSection";
import { OurSalonsHours } from "@/components/sections/nos-salons-hours/OurSalonsHours";
import { SeoSection } from "@/components/sections/SeoSection";
import { RelatedArticles } from "@/components/sections/RelatedArticles";
import { blogPosts } from "../../blog/data/blog/blog";
import Link from "next/link";
import PrivatisationForm from "../components/PrivatisationForm";

export default function ServiceDetailPage({
  params,
}: {
  params: { slug: string };
}) {
  // Bloquer l'accès aux prestations désactivées
  const disabledServices = ["soin-balinet", "privatisation-lieu"];
  if (disabledServices.includes(params.slug)) {
    notFound();
  }

  const currentService = Object.values(ServicesContent).find(
    (service) => service.id === params.slug,
  );

  if (!currentService) {
    notFound();
  }

  const isPrivatisationPage = params.slug === "privatisation-lieu";
  const isHeadSpaPage = params.slug === "head-spa";

  return (
    <>
      <Banner
        title={currentService.bannerTitle}
        backgroundImage={currentService.bannerImage.src}
      />

      <DescriptionFirst
        imagePath={currentService.firstSection.imagePath}
        title={currentService.firstSection.title}
        content={currentService.firstSection.content}
      />

      <DescriptionSecond
        title={currentService.secondSection.title}
        content={currentService.secondSection.content}
      />

      {params.slug === "visagiste" && (
        <PastWorks
          title={currentService.fourthSection.title}
          images={currentService.fourthSection.images}
        />
      )}

      <DescriptionThird
        title={currentService.thirdSection.title}
        content={currentService.thirdSection.content}
      />

      {isPrivatisationPage && <PrivatisationForm />}

      {isHeadSpaPage && process.env.NODE_ENV === "production" ? (
        <HeadSpaReviewsWidget />
      ) : (
        <ReviewsSection />
      )}
      <OurSalonsHours />
      <SeoSection />

      <RelatedArticles
        initialPosts={blogPosts}
        keywords={[
          currentService.title?.toLowerCase() ?? "",
          "coiffure",
          "technique",
          ...(currentService.keywords ?? []),
        ]}
        type="prestation"
      />
    </>
  );
}
